import React, { useEffect, useState } from 'react'
import Modal from '@gwp-components/modal'
import GWPButton from '@gwp-components/button'

const LOCAL_STORAGE_PREFER_NO_MODAL_KEY = 'gwpHideGeoipModalCG';

/**
 * Returns the default object to feed into CG Modal
 * @param {string} modalId Unique identifier for the Modal
 * @returns {Object}
 */
const argumentDefaults = (modalId) => {
  return {
    backdropStyle: 'dark',
    modalId,
    showsCloseIcon: true,
    size: 'large',
    cssClasses: 'bg-gray07',
    attributes: {
      'data-targetmodalid': modalId
    },
    open: true
  }
}

const geoData = {}

/**
 * Returns the value of the required query parameter, not found returns null.
 * @param {string} name  Name of the query parameter.
 * @returns {string}
 * Eg - CA or US depending on the country passed in the parameter
 */
const getURLParameter = (name = '') => {
  if (name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
    const regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
      results = regex.exec(location.search)
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
  }
  return null
}

/**
 * Returns the value of the cookie
 * @param  {string} name - the name of the cookie
 * @returns {string}
 */
export const getCookie = (name) => {
  const cookie = document.cookie
  const start_index = cookie.indexOf(`${name}=`)
  if (start_index !== -1) {
    const { length } = name
    const val_index = start_index + length + 1
    const end_index =
      cookie.indexOf(';', val_index) !== -1 ? cookie.indexOf(';', val_index) : cookie.length
    return decodeURIComponent(cookie.substring(val_index, end_index))
  }
  return ''
}

export const getTTcaURL = (languageCode = '') => {
  return languageCode?.toLowerCase() === 'fr'
    ? 'https://turboimpot.intuit.ca/'
    : 'https://turbotax.intuit.ca/'
}

/**
 * Check the user visited page and help user to route coutry specifc page
 * @returns {boolean}
 */
const isGeoIpDataCheck = () => {
  const forceCountry = getURLParameter('country')
  const geoLocation = getCookie('AKES_GEO') //ex: US~EN or CA~FR
  const regionCode = getCookie('REGION') || 'US'
  const geoLocationCountry = geoLocation && geoLocation.split('~')[0]
  const countryCode = forceCountry || geoLocationCountry || 'US'
  const prefersNoModal = typeof window !== 'undefined' && window.localStorage?.getItem(LOCAL_STORAGE_PREFER_NO_MODAL_KEY);
  if (prefersNoModal === 'true') {
    return false
  }
  if (countryCode === 'CA') {
    const languageCode = geoLocation?.split('~')[1] || 'EN'
    geoData.modalShow = 'goip-modal-show'
    geoData.geoPageUrl = getTTcaURL(languageCode)
    geoData.regionCode = regionCode
    geoData.countryCode = countryCode
    return true
  }
  return false
}

/**
 * Returns the value of the geoData object
 * Written for testing purposes only
 * @returns {Object}
 */
export const geoDataInfo = () => {
  return geoData
}

/**
 * GEOIP modal to route a user to coutry specifc pages for CG
 * To Show up on CG pages where users location is different from the site they are trying to access
 * Mainly for US CA
 * @returns {React.ReactElement}
 */
const GeoipModalCG = () => {
  const [showGeoipModal, setShowGeoipModal] = useState(false)
  const [geoipModalUrl, setGeoipModalUrl] = useState('')
  let modalShow = 'goip-modal-hide'

  useEffect(() => {
    setShowGeoipModal(isGeoIpDataCheck())
  }, [])

  useEffect(() => {
    const geoData = geoDataInfo()
    setGeoipModalUrl(geoData.geoPageUrl)
    modalShow = showGeoipModal ? geoData.modalShow : 'goip-modal-hide'
  }, [geoData, showGeoipModal])

  const onClickNoThanks = () => {
    typeof window !== 'undefined' && window.localStorage?.setItem(LOCAL_STORAGE_PREFER_NO_MODAL_KEY, 'true');
  }

  return (
    <>
      {showGeoipModal && (
        <Modal {...argumentDefaults('geoip-modalCG')}>
          <div>
            <div style={{ display: 'inline-block', marginBottom: '16px' }}>
              <img
                data-src="https://digitalasset.intuit.com/IMAGE/A7WkHKfFO/thumb_1738036.png"
                alt=""
                height=""
                src="https://digitalasset.intuit.com/IMAGE/A7WkHKfFO/thumb_1738036.png"
              />
            </div>
            <h2>Looks like you're in Canada</h2>
            <p>If that's where you file your taxes, you'll want to visit our Canadian website.</p>
          </div>
          <div style={{ padding: '32px' }}>
            <GWPButton
              size="large"
              purpose="special"
              priority="primary"
              theme="turbotax"
              colorScheme="light"
              text="Take me to TurboTax Canada"
              onClick={() => (location.href = geoipModalUrl)}
            />
            <div>
              <br />
              <a href="https://turbotax.intuit.com/" onClick={onClickNoThanks}>
                No thanks, take me to the U.S. TurboTax site
              </a>
            </div>
          </div>
        </Modal>
      )}
    </>
  )
}

export { GeoipModalCG as default }
